var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewHairstyle1C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_hair_x5F_new:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new_x5F_1a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M484.9,194.1c-8.9-33.4-20.3-60.1-42.4-86.9c-8.1-9.8-27.7-23.8-40.5-24.9c-17.9-1.5-29,2.2-44.1,10.1 c-15.2-7.9-24.7-11.2-43.4-8.7c-15,2-33.2,13.6-41.3,23.4c-22.2,26.8-33.6,53.5-42.4,86.9c-16.7,62.8-12.9,129.4-11.3,193.8 c1.9,77.1,2,156.9,3.9,234.1c8.4-1.8,19.8-2.4,28-0.8l2.4,1.3l0.7-47.5l-2.9-16.2l10.7,60.3v-0.2c0.1,0.8,0.1,1.4,0.1,1.4 l6.5-20.3l1.5,24.7c14.8-3.3,37.4-5.2,52.7,0.6l-4-229.4c-3.1-2.8-6.2-5.8-8.9-8.4c-12-11.5-20.2-21.4-29.1-35.5 c-6.7-10.6-14.6-35.3-16.9-47.2c-8.2,2.8-12.8-3.7-15-13.5c-2.3-10.3-4.2-13.2-4.8-24.2c-0.4-6.5,4.4-15.7,8.8-17.5 c6.9,13.1,8.4,33,10.8,45c1.8-17.3,1.9-37.7,6.8-52.8c7-3.4,13.2-8.2,18-15.7c3.3-4.1,6.2-8.6,8.8-13.1s4.9-9.1,6.9-13.5 c0.4-0.8,0.8-1.6,1.2-2.4c1.8-0.6,3.7-1.1,5.5-1.6c6.1-1.7,12.2-3.1,18.5-4.2c0.3-0.1,0.6-0.1,0.9-0.1c1.2-0.2,2.5-0.4,3.7-0.6 l0,0c1.9-8.5,5.3-20.2,8.7-24.5c-2,6-3.6,17-3.1,23.9c0.6-0.1,1.3-0.1,2-0.2l0,0c4.4-0.4,8.9-0.5,13.5-0.4s9.9,0.4,15.4,0.8 c0.9-4,1.3-8.8,1.5-12.8c1.6,4,3.3,9.7,3.6,13.2c0.1,0,0.2,0,0.3,0c0.7,0.1,1.4,0.1,2.1,0.2c2.5,0.3,5.1,0.6,7.7,1 c-0.9-13.4-5.8-26.1-9.5-34.4c0.1,0.1,0.1,0.1,0.2,0.2c2,2.1,4.2,5.8,5.6,8.3c0.6,1.1,5.5,7.6,11.4,27.3c0.9,0.2,1.8,0.4,2.7,0.6 c1.2,0.3,2.3,0.5,3.5,0.8c3.7,0.9,7.1,2.1,10.3,3.4c0.3,0.6,0.6,1.1,0.8,1.7c2,4.4,4.2,9,6.9,13.5s5.6,8.9,8.8,13.1 c4.8,7.5,11.1,12.2,18,15.7c5,15.1,8.6,33,9.1,50.1c2-14.2,3.8-28.1,10.8-41.2c4.7,1.6,10.1,5.7,9.7,12.5 c-0.6,10.9-8,21.1-10.4,31.4c-2.2,9.8-2.3,9.6-9.8,10.6c-0.1,0-1.6,9.7-1.7,9.7c-9,33.5-31.9,60.7-56.4,82.8l-3.5,225.1 c8.3-2.3,21.6-3.4,31-1.7v0.2l3.5,1.2l-1-53.3l8.8,50l6.3-24l-6.3,23.9l0.2,1.6l6.5-19.6l1.5,23.7c13.7-3.1,34.1-4.9,49.2-0.5 c2-77.9,2-158.5,4-236.4C497.8,323.5,501.6,256.8,484.9,194.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M349.2,141.9c2.6-1.9,4.8-3.7,8.8-5.7c14,6.6,25.3,17.4,36.1,31.1c-3.6-5.9-7.4-11.3-11.7-15.6 c-4-4.3-8.4-8.3-13.2-11.7c-3.6-2.6-7.4-4.9-11.4-6.9c-4,2-7.8,4.3-11.4,6.9c-4.8,3.5-9.1,7.4-13.2,11.7 c-7.5,7.7-13.7,18.5-19.7,30.2c-2.6,5-5.1,10.2-7.7,15.3c1.8-0.6,3.7-1.1,5.5-1.6C319.1,175.6,331.7,154.5,349.2,141.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M268.7,595.2l-6.3,23.8l0,0c0.1,0.8,0.1,1.4,0.1,1.4l6.5-20.3l0,0L268.7,595.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9D7641",
    points: "441.2,595.2 434.9,619.1 435,620.8 441.5,601.1 441.5,601.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M424.2,558.8l0.6,62.5c-0.4-0.1-0.9-0.2-1.3-0.3l0,0v0.2l3.5,1.2l-1-53.3l0,0L424.2,558.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M251.4,621.2L251.4,621.2l2.4,1.3l0.7-47.5l-2.9-16.2l0.6,62.5C252,621.3,251.7,621.2,251.4,621.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M361.1,123.6c20.3-1.9,45.8,14.8,55.9,34.1c-9.5-25.6-34.2-39.5-55.4-36.5c0.4-2.3,0.7-4.9,0.9-7.4 c7.3-6.6,27.1-8,36.8-1.1c-9-10.2-29.7-7.5-36.6-2c0.1-2.3,0-4.6-0.3-6.8c11.4-13.6,36.5-17.2,51.2-7.5 c-13.7-12.7-38.9-8.2-51.6,4.9c-0.5-2.7-1.3-5-2.5-6.9c0.3,2.4,0.4,4.9,0.5,7.5c-6.6-5.1-16.1-8.4-26.2-7.2 c9.6,1,19.2,3.3,26.3,10c0,2.1-0.1,4.3-0.2,6.4c-11.9-9.7-36-9.7-45.8,3.1c10.9-9.9,34-11.7,45.6,0.3c-0.1,2.2-0.3,4.3-0.5,6.4 c-20.1-10.1-43.7,5.7-53.1,23.5c13.7-15.7,33.4-31,52.7-20.2l0.1-0.4c-0.3,2.9-0.5,5.6-0.6,8 C359.3,130.1,360.3,127.2,361.1,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M331,137.8c-25.3,15.4-34.1,41.6-49.4,65.7c-13,20.6-28.5,39.8-54.4,41.6c25.5-0.7,44.7-17.7,58.4-39.1 C301.6,181.2,305.7,154,331,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M331,137.8L331,137.8L331,137.8L331,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M263,217.4c11-14,14.6-28.5,23-43.1l0,0c-8.7,14.4-16.4,26.9-26.6,40.2c-8.8,11.2-18.2,20.7-32.6,24.4 C240.9,236.1,253.3,229.3,263,217.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M484.8,272.3L484.8,272.3c-0.1-11.5-3.1-22.7-11.2-30.8c-8.1-7.5-16-14.5-23.9-23.1 c-13.5-14.6-24.4-28.9-28.7-48.7c3.5,19.6,11.3,36.5,25.3,51.9c8,8.9,17.1,15.5,25.6,21.9C480.1,250.1,484.5,260.8,484.8,272.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M439.4,125.4L439.4,125.4c17,17.2,23.7,37,32.4,59.3c6.9,19.6,15.9,35.8,17.1,56.6 c-0.6-20.7-5.9-38.3-12.8-58.2C467.6,160.2,456.6,141.8,439.4,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M260.6,169.2L260.6,169.2c-8.3,10.3-15.6,19.5-21.8,31.6c-5.3,10.6-7.7,20.6-10.7,31.7 c3.6-11,9.4-19.3,14.8-29.6C249.3,191,252.6,180,260.6,169.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M447.9,179c1.7,14.4,7.4,26.9,16.4,38.9c7.8,10.3,16.2,17.9,20.6,30c-3.6-12.2-9.1-22.4-16.8-32.8 C459.4,203.2,450.1,193.6,447.9,179L447.9,179z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M229.1,439.1c-0.5-49.3-1.7-91.4,3.2-139.6c-5.6,48-8.2,90.1-7.9,139.6c0.8,57.1,3.2,105.1,9,160.6v-0.1 C228,544,230.1,496.1,229.1,439.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M303.7,595.9L303.7,595.9c3.6-35.6,5.2-66.5,2.5-103c-2.5-31.7-7.6-58.2-11.5-88.9 c3.2,30.8,4.5,57.7,6.8,89.2C304,529.6,306.8,560.2,303.7,595.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M267.8,507.5c-0.1-1.7-0.3-3.5-0.6-5.3c0,0.5,0,0.9,0,1.4c-0.5,32,1.3,59.1-2.5,90.3v-0.1 c4.3-31.1,7-58,7.2-90.2c-0.1-27.9-2.8-51.5-4.3-78.6c0.6,21.3,0.1,40.4-0.2,61C268.8,493.8,269.1,501.5,267.8,507.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M253.9,535L253.9,535c0-14.2,0.1-27.2,0.2-40.5c-0.2,1.5-0.4,3-0.5,4.4l-1.5-12c0.4-2.5,1.1-5.2,2-7.9 c-0.1-5.7-0.2-11.5-0.4-17.5c-0.6-22.5-2.1-41.7,0.7-63.7c-3.5,21.8-5.7,41.1-5.3,63.8C249.5,487.9,253.4,509.5,253.9,535z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M481.7,359.3c0-1.1,0-2.2-0.1-3.3c1,3.5,1.1,6.9,0.6,10.3c2.3,33.7,0.9,66.6,0.4,103.3 c-1.2,46.2-1.4,85.5-4.9,130.6c4.2-45,8.1-84.2,9.6-130.5c1-53.4-0.9-98.6-10.7-149.8C479,333.4,480.6,346.5,481.7,359.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M476.5,319.8v0.1l0,0V319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M470.1,354.7c0.2,1.2,0.5,2.4,0.8,3.5c-1.7-10.6-4-20.7-6.6-31.6c3.3,16.7,3.3,31.6,4.3,48.8 c1.1,19.9,2.9,36.8,2.6,56.4l0,0c0.8-19.6,3-36.4,1.7-56.6c-0.2-2.5-0.4-4.9-0.7-7.3c-0.7-1.8-1.3-3.6-1.7-5.2L470.1,354.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M441.1,480.7c-1.1,37.5-1.6,69.2-4.8,105.8v-0.1c3.6-36.6,8.6-67.9,9.5-105.6c0.6-32.7-2.1-60.5-6-92.1 C443,420.5,441.9,448.2,441.1,480.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M466.6,555.6c-2.2,20.5-3.4,38-8.2,57.9l0,0c5.2-19.6,10.8-36.4,12.8-57.4c1.7-18.1,0.1-33.6-1.4-51.1 C470.7,522.6,468.4,537.8,466.6,555.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M419.1,461.8c-0.8-25.9-2.5-48.1-0.3-73.5c-2.9,25.3-5,47.5-4.4,73.7c0.8,30.2,5,55.2,7.4,84.5v-0.1 C419.9,517.1,420.1,491.8,419.1,461.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M319,91.5L319,91.5c-17.2,3.7-31.3,11.9-43.2,25.7c-10.2,12.2-15.7,24.6-21.3,38.8 c5.9-14.1,13.5-25.2,23.4-37C289.5,105.8,301.6,95.6,319,91.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M255,210L255,210c12.4-15.3,20.5-30.3,30.5-47.6c8.7-14.6,15.7-28.7,31-36.9 c-15.4,7.7-24.5,20.7-33.4,35.5C272.9,178.4,267.2,194.5,255,210z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M454.2,168.4c9.6,16.2,17.7,30.1,23.4,47.9l0,0c-5.4-17.8-10.2-33.3-20.2-49.8c-8.9-14-18.4-25-31.2-34.8 C438.8,142,445.6,154.6,454.2,168.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M378.5,97.9c9.4-1.4,17.8,0,26.8,2.9c10.3,3.6,18.9,8.4,25.3,17.5l0,0c-6.1-9-13.8-15.6-24.7-19.3 C396.5,96.1,387.8,96.2,378.5,97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M245.1,542.3L245.1,542.3c-2.9-34.6-4.3-64.2-4.8-99.5c-0.3-30.5,0-56.7,6.3-86.1 c-6.8,29.2-10.2,55.4-10,86.2C236.9,478.4,241.8,507.8,245.1,542.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M285,606L285,606C285,606.1,285,606.1,285,606L285,606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M290.6,536.8c-0.6-21.4-3.4-39.5-5.1-60.3c1.2,20.9,0.9,39.1,1.3,60.4c0.4,24.5,1.5,45.3-1.8,69.2 C288.7,582.2,291.2,561.5,290.6,536.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M404.5,507.5c-0.1-27-1.2-50-1.8-76.5c0.1,26.5-1.8,49.4-1.9,76.5c0,31.3,2.3,57.5,5.6,87.9v-0.1 C403.4,564.9,404.7,538.7,404.5,507.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M454.3,345.8c4,29.7,4.2,55.7,4.1,86.2c-0.4,35.2-1.1,64.9-5.9,99.1V531c5.1-34.1,9.4-63.5,9.6-99 C462.1,401.3,458.9,375.3,454.3,345.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M405,126.3C405,126.2,405,126.2,405,126.3C405,126.2,405,126.2,405,126.3L405,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M387.1,113c-6.8-1.5-13.4-1.4-19.2,2.2c6.1-3.3,12.4-1.9,18.8-0.4c7.3,2.1,13.9,4.9,18.4,11.4 C400.8,119.7,394.9,115.2,387.1,113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M289,132c5.2-9.8,12-17.1,21.3-23.1c10.9-6.6,22.3-9.6,34.9-7.2l0,0c-12.4-2.6-24.4-1.4-35.9,5.6 C299.6,113.7,293.9,122.1,289,132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M353.2,147c-11.6,10.7-20.1,28.7-23.4,44.4l0,0c0.3-0.1,0.6-0.1,0.9-0.1c1.3-0.2,2.5-0.4,3.7-0.6 c1.9-8.5,5.3-20.2,8.7-24.5c-2,6-3.6,17-3.1,23.9c0.6-0.1,1.3-0.1,2-0.2l0,0C341.8,169.1,347.5,159.2,353.2,147z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M372.5,172.5c0,1.5-0.1,3.2-0.1,5c1.6,4,3.3,9.7,3.6,13.2c0.1,0,0.2,0,0.3,0c0.7,0.1,1.4,0.1,2.1,0.2l0,0 C377.4,185,375.5,178.4,372.5,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M376.7,157.6c2,2.1,4.2,5.8,5.6,8.3c0.6,1.1,5.5,7.6,11.4,27.3c0.9,0.2,1.8,0.4,2.7,0.6 c1.2,0.3,2.3,0.5,3.5,0.8l0,0C395.4,180.8,388.6,166.9,376.7,157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7BC77",
    d: "M418.9,195.4c-5.4-12.8-9.8-24.2-11.8-37.9c1.5,13.7,2.9,26,8.3,39.4c6.5,15.4,16.1,26.2,28.2,36.5l0,0 C431.6,222.6,425.4,210,418.9,195.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M253.5,499c0.1-1.5,0.3-2.9,0.5-4.4c1.2-8.4,3.3-16.8,6.1-23.7c2.4,9.4,5.7,21,7.1,31.4 c0.2,1.8,0.4,3.6,0.6,5.3c1.2-6,0.9-13.7-0.4-21.5c-1.5-8.8-4.3-17.8-7.6-24.5c-1.4,5.3-4,11.6-5.9,17.6c-0.9,2.7-1.6,5.4-2,7.9 L253.5,499z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D7641",
    d: "M481.6,356.1c0.1,1,0.1,2.1,0.1,3.3c-0.2,5.3-1.7,11.4-3.9,15.3c-1.4-2.6-4.8-8.6-6.8-16.5 c-0.3-1.1-0.6-2.3-0.8-3.5l0.4,8c0.3,1.6,0.9,3.4,1.7,5.2c1.6,3.8,3.8,7.7,5.7,10.3c2.1-3.5,3.7-7.5,4.3-11.8 C482.7,363,482.6,359.5,481.6,356.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHairstyle1C);
export default __webpack_public_path__ + "static/media/new_hairstyle_1c.c70f7005a18e5020aceb3d4fcf6c0020.svg";
export { ForwardRef as ReactComponent };